import { Skeleton } from '@mui/material';
import { keyframes } from '@mui/system';

const shimmer = keyframes`
  0%   { background-position: -200% 0; }
  100% { background-position:  200% 0; }
`;

const AnimatedSkeleton = props => (
	<Skeleton
		{...props}
		sx={{
			background: 'linear-gradient(90deg, #f0f0f0 25%, #ffffff 50%, #f0f0f0 75%)',
			backgroundSize: '200% 100%',
			animation: `${shimmer} 1.2s linear infinite`,
			...props.sx
		}}
	/>
);

export default AnimatedSkeleton;
